import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { data } from '../constants/avgNightlyRates';

export default function AveragePricing({ city }) {
  return (
    <div
      style={{
        width: '100%',
        height: '500px',
        overflowX: 'auto',
        overflowY: 'hidden',
      }}
    >
      <ResponsiveContainer minWidth={830}>
        <BarChart width={730} height={400} data={data[city]}>
          <CartesianGrid horizontal vertical={false} />
          <XAxis dataKey="month" tickLine={false} />
          <YAxis
            interval="preserveStartEnd"
            tickFormatter={e => `$${e}`}
            tickLine={false}
            axisLine={false}
          />
          <Bar dataKey="price" fill="#073655" barSize={16} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

AveragePricing.propTypes = {
  city: PropTypes.string.isRequired,
};
